import * as z from 'zod'
import { zodRequiredField, zodValidateMinMax, zodMessages } from '@/shared/config/zod/schema'
import { fieldNames } from '@/shared/constants/field-names'

export const dto = z.object({
  [fieldNames.PASSWORD]: zodValidateMinMax(6, 1000),
  [fieldNames.EMAIL]: zodRequiredField().email(zodMessages.validEmail),
})
